// Core React libraries import
import React from 'react';

// Core ANTD and 3rdparty libraries import
import { Row, Col } from 'antd';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { InfoCircleOutlined } from '@ant-design/icons';

// EZ web-app utils import
import { GOOGLE_CLIENTID } from 'utils/envUtil';

// EZ web-app components import
import { GoogleCalendarLoginSection } from './Integration/GoogleCalendarLoginSection';
import { MicrosoftCalendarLoginSection } from './Integration/MicrosoftCalendarLoginSection';

// EZ web-app styles and assets import

export function SubTab_CalendarIntegration() {
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENTID}>
            <div className="ez-sub-content-wrapper">
                <div className="pr-3 pl-4 text-help mb-3" style={{ textAlign: 'left' }}>
                    <InfoCircleOutlined /> Tip: Authorize Google or Microsoft 365 to enable Calendar
                    integration. For now, this only starts the OAuth flow to connect your account.
                </div>

                <Row className="row-wrapper" gutter={16}>
                    <Col span={12}>
                        <GoogleCalendarLoginSection />
                    </Col>
                    <Col span={12}>
                        <MicrosoftCalendarLoginSection />
                    </Col>
                </Row>
            </div>
        </GoogleOAuthProvider>
    );
}
